import React from 'react';

import { Text } from '@betterment/samba-react';
import { faker } from '@faker-js/faker'; // eslint-disable-line import/no-extraneous-dependencies

export enum MessageDirection {
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}

export type ChatMessage = {
  content: string;
  direction: MessageDirection;
};

export const Message: React.FC<ChatMessage> = ({ content, direction }) => {
  const isIncoming = direction === MessageDirection.Incoming;

  return (
    <Text
      as="p"
      color="text"
      variant="text100"
      css={{
        alignSelf: isIncoming ? 'flex-start' : 'flex-end',
        background: isIncoming ? 'transparent' : 'background.accent.blue',
        borderRadius: '4px',
        maxWidth: '70%',
        paddingY: 'space.150',
        paddingX: 'space.200',
        wordBreak: 'break-word',
      }}
    >
      {content}
    </Text>
  );
};

export const fakeInitialMessages: ChatMessage[] = [
  { content: faker.lorem.sentence(), direction: MessageDirection.Outgoing },
  { content: faker.lorem.paragraph(), direction: MessageDirection.Incoming },
  { content: faker.lorem.sentence(), direction: MessageDirection.Outgoing },
  { content: faker.lorem.paragraph(), direction: MessageDirection.Incoming },
];
